<style lang="less" scoped>
    .container,
    .map {
        // height: 100%;
        // width: 100%;
         width: 900px;
        height: 600px;
        position: relative;
    }

    .map-rank {
        position: absolute;
        z-index: 999;
        display: flex;
    }

    .map-rank .num {
        background-image: linear-gradient(-24deg, rgba(255, 19, 104, .6), rgba(71, 80, 193, 96));
        border: 1px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
        display: block;
        width: 18px;
        border-radius: 50%;
        font-style: normal;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        color: #fff;
        text-align: center;
        margin-right: 2px;
        align-items: flex-start;
    }

    .map-rank .city {
        font-size: 12px;
        color: #ffffff;
        line-height: 18px;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    }

    .map-rank .value {
        font-family: "AgencyFB-Reg";
        font-size: 12px;
         line-height: 12px;
        color: #ffffff;
        letter-spacing: 0;
    }

    .map-rank-1 {
        right: 281px;
        top: 308px;
    }

    .map-rank-2 {
        right: 286px;
        top: 498px;

    }

    .map-rank-3 {
        right: 296px;
        top: 423px;

    }

    .map-rank-4 {
        right: 212px;
        top: 325px;

    }

    .map-rank-5 {
        right: 240px;
        top: 354px;

    }

    .map-rank-6 {
        right: 400px;
        top: 378px;

    }

    .map-rank-7 {
        right: 253px;
        top: 405px;
    }

    .map-rank-8 {
        right: 243px;
        top: 273px;
    }

    .map-rank-9 {
        right: 200px;
        top: 383px;
    }

    .map-rank-10 {
        right: 249px;
        top: 219px;
    }
</style>
<template>
    <div class="container">
        <div class="map" ref="map"></div>
        <div class="map-rank" v-for="(it,index) in flysRanks" :key="it.value" :class="'map-rank-'+(index+1)">
            <i class="num">{{index+1}}</i>
            <div class="detail">
                <p class="city">{{it.to.name}}</p>
                <p class="value">{{it.value}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import labourPerson from "./labourPerson.js";
    import echarts from 'echarts';
    const top10 = labourPerson.slice(0, 10);
    import config from "./map.config";
    import geoData from "./baseData/china.json";
    export default {
        name: "",
        data() {
            return {
                flysRanks: top10
            };
        },
        methods: {
            init() {
                const echarts1Elem = echarts.init(this.$refs.map);
                echarts1Elem.setOption(config);
            }
        },

        mounted() {
            echarts.registerMap("china", geoData);
            this.$nextTick(() => {
                this.init();
            });
        }
    };
</script>